import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  // Start at 8 minutes and 45 seconds (525 seconds)
  const [timeLeft, setTimeLeft] = useState(525);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 bg-accent text-white py-2 px-3 sm:py-3 sm:px-4 shadow-md" data-id="element-262">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 sm:gap-4 text-center text-xs sm:text-base font-medium" data-id="element-263">
        <span className="font-bold uppercase tracking-wider text-xs bg-white/20 px-2 py-0.5 sm:py-1 rounded" data-id="element-264">
          ¡Oferta!
        </span>
        <span className="hidden sm:inline" data-id="element-265">
          60% de descuento solo por las próximas
        </span>
        <div className="flex items-center gap-1.5 font-bold bg-white text-accent px-2 py-0.5 sm:px-3 sm:py-1 rounded-md shadow-sm" data-id="element-266">
          <Clock className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-267" />
          <span className="tabular-nums" data-id="element-268">{formattedTime}</span>
        </div>
        <span className="hidden sm:inline" data-id="element-269">•</span>
        <span className="hidden sm:inline text-white/90 text-sm" data-id="element-270">
          Quedan 12 cuotas disponibles.
        </span>
      </div>
    </div>;
}